<template>
  <div class="language-switcher">
    <select 
      v-model="currentLanguage" 
      @change="changeLanguage"
      class="lang-select"
      :title="getLanguageTitle()"
    >
      <option value="zh-TW">繁體中文</option>
      <option value="zh-CN">简体中文</option>
      <option value="en-US">English</option>
      <option value="ja-JP">日本語</option>
    </select>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useI18nRouter } from '@/composables/useI18nRouter'

const { locale } = useI18n()
const { switchLocale } = useI18nRouter()

const currentLanguage = computed({
  get: () => locale.value,
  set: (value) => {
    locale.value = value
    localStorage.setItem('locale', value)
  }
})

const changeLanguage = async () => {
  const newLocale = currentLanguage.value
  localStorage.setItem('locale', newLocale)
  
  // 切換語言並導航到當前頁面的對應語言版本
  await switchLocale(newLocale)
}

const getLanguageTitle = () => {
  const titles = {
    'zh-TW': '繁體中文',
    'zh-CN': '简体中文',
    'en-US': 'English',
    'ja-JP': '日本語'
  }
  return titles[currentLanguage.value] || 'Language'
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
}

.lang-select {
  padding: 0.5rem 1rem;
  background: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.5rem;
  color: var(--color-primary);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  min-width: 120px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%233b82f6' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px;
  padding-right: 2.5rem;
}

.lang-select:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: rgba(59, 130, 246, 0.5);
}

.lang-select:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.lang-select option {
  background: var(--bg-primary, #1a1a1a);
  color: var(--text-primary, #ffffff);
  padding: 0.5rem;
}

@media (max-width: 768px) {
  .lang-select {
    padding: 0.4rem 0.8rem;
    padding-right: 2rem;
    font-size: 0.75rem;
    min-width: 100px;
  }
}
</style>

